import { Facet } from '../SearchModels';

export const isSelected = (facet: Facet, urlSearchParams?: URLSearchParams) =>
  facet.filters.filter((x) => x.selected).length ||
  (urlSearchParams?.get(`${facet.id}.min`) || urlSearchParams?.get(`${facet.id}.max`) ? 1 : 0);
